import React from 'react';
import { AnnouncementBar } from './components/landing/AnnouncementBar';
import { Hero } from './components/landing/Hero';
import { PainPoints } from './components/landing/PainPoints';
import { ImagineBenefits } from './components/landing/ImagineBenefits';
import { Solutions } from './components/landing/Solutions';
import { OfferCard } from './components/landing/OfferCard';
import { Bonuses } from './components/landing/Bonuses';
import { Testimonials } from './components/landing/Testimonials';
import { Faq } from './components/landing/Faq';
import { Comparison } from './components/landing/Comparison';
import { SiteFooter } from './components/landing/SiteFooter';
export function App() {
  return <div className="min-h-full w-full bg-cream" data-id="element-0" data-mp="2wjgpfdsj9neb">
      <AnnouncementBar data-id="element-1" data-mp="2wip734ny5m5z" />
      <main data-id="element-2" data-mp="28ufqch5lbolp">
        <Hero data-id="element-3" data-mp="28u5z6q8t7bef" />
        <PainPoints data-id="element-4" data-mp="28tmdcyg1g2v4" />
        <ImagineBenefits data-id="element-5" data-mp="28t4k8aooa4rf" />
        <Solutions data-id="element-6" data-mp="28sb9kymlev40" />
        <OfferCard data-id="element-7" data-mp="23vcikoy874a1" />
        <Bonuses data-id="element-8" data-mp="23vulg4fe8gqx" />
        <Testimonials data-id="element-9" data-mp="23u9qidp62vsj" />
        <Faq data-id="element-10" data-mp="23v2sz2h3ez4v" />
        <Comparison data-id="element-11" data-mp="23ti8y6semyl9" />
      </main>
      <SiteFooter data-id="element-12" data-mp="3ikhaeg9qb525" />
    </div>;
}